var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { AppState } from "@/share/AppState";
import { DateLib } from "@@/Datelib";
import { SearchDataType, SearchType } from "@@/ModuleJob";
import { action, observable, makeObservable } from "mobx";
export class SearchStore {
    constructor() {
        this.activesearchtag = "files";
        this.activematchtype = SearchType.Phrase;
        this.searching = false;
        this.matchmessage = "";
        this.loadingmessage = "Searching";
        this.orderListItems = [];
        this.displayItems = [];
        this.miniletrs = new Map();
        this.showadvance = false;
        this.letrids = [];
        this.activeletrid = "";
        this.searchid = "";
        this.searchterm = "";
        this.objectstermsmap = new Map();
        this.loadingmore = false;
        this.activeitemid = "";
        makeObservable(this);
        APPEvent.addSubscriberForAppState((st) => {
            if (st !== AppState.LoggedIn) {
                this.reset();
            }
        });
        APPEvent.addSubscriberForMiniLetrs((lts) => {
            if (this.searching && this.searchid === lts.reqid) {
                this.setMiniLetrs(lts.miniletrs);
                if (lts.miniletrs.length === 0) {
                    this.setSearching(false);
                    this.setLoadMore(false);
                    this.setMatchMessage("No matches found");
                }
                else {
                    this.checkAndLoadLetrs();
                }
            }
            ;
        });
        APPEvent.addSubscriberForMsgByIds((res) => {
            if (res.letrid === this.activeletrid && res.reqid === this.searchid) {
                // we have now everything we need!!
                res.msgs.forEach((msg) => {
                    var _a;
                    const ditem = {
                        id: msg._id,
                        title: "By " + msg.user.name,
                        subheading: "On " + (DateLib.displayTime(msg.createdAt)),
                        body: msg.text,
                        actualobj: msg,
                        letrsubject: (_a = this.miniletrs.get(res.letrid)) === null || _a === void 0 ? void 0 : _a.subject,
                        letrid: this.activeletrid,
                        match: new Map()
                    };
                    this.addMatchDisplayItem(ditem);
                });
                if (this.orderListItems.length > 0 && res.msgs.length < 100) {
                    const ids = this.orderListItems.splice(0, 100);
                    this.loadObjects(ids.map(id => id.itemid));
                }
                else if (res.msgs.length > 90) {
                    this.setSearching(false);
                    this.setLoadMore(false);
                }
                else {
                    if (this.displayItems.length < 20 || res.msgs.length < 10) {
                        this.checkAndLoadLetrs();
                    }
                    else {
                        this.setSearching(false);
                        this.setLoadMore(false);
                    }
                }
            }
        });
        APPEvent.addSubscriberForProjectObjectDetails((res) => {
            if (res.letrid === this.activeletrid && res.reqid === this.searchid) {
                res.objs.forEach((obj) => {
                    var _a;
                    const mres = this.objectstermsmap.get(obj.id);
                    if (mres !== undefined) {
                        const mbypage = new Map();
                        mres.position.forEach((pos) => {
                            var _a;
                            if (!mbypage.has(pos.position.pagenumber)) {
                                mbypage.set(pos.position.pagenumber, new Set());
                            }
                            (_a = mbypage.get(pos.position.pagenumber)) === null || _a === void 0 ? void 0 : _a.add(pos.position.actualposition);
                        });
                        console.log(mbypage);
                        const ditem = {
                            id: mres.itemid,
                            title: obj.name,
                            subheading: this.activematchtype === SearchType.Phrase ? "" :
                                "Found terms: " + (Array.from(mres.terms).join(" ")),
                            body: "",
                            actualobj: obj,
                            letrsubject: (_a = this.miniletrs.get(res.letrid)) === null || _a === void 0 ? void 0 : _a.subject,
                            letrid: this.activeletrid,
                            match: mbypage
                        };
                        this.addMatchDisplayItem(ditem);
                    }
                });
                if (this.orderListItems.length > 0 && res.objs.length < 100) {
                    const ids = this.orderListItems.splice(0, 100);
                    this.loadObjects(ids.map(id => id.itemid));
                }
                else if (res.objs.length > 90) {
                    this.setSearching(false);
                    this.setLoadMore(false);
                }
                else {
                    if (this.displayItems.length < 20 || res.objs.length < 10) {
                        this.checkAndLoadLetrs();
                    }
                    else {
                        this.setSearching(false);
                        this.setLoadMore(false);
                    }
                }
            }
        });
        APPEvent.addSubscriberForLetrSearch((res) => {
            if (this.searching && this.searchid === res.reqid && this.activeletrid === res.letrid) {
                if (res.matches !== undefined) {
                    const pids = new Set();
                    for (const re of res.matches.result) {
                        for (const d of re.indexdata) {
                            pids.add(d.itemid);
                        }
                    }
                    if (pids.size === 0) {
                        this.checkAndLoadLetrs();
                    }
                    else {
                        this.arrangeResult(res.matches);
                    }
                }
                else {
                    this.checkAndLoadLetrs();
                }
            }
        });
    }
    setMiniLetrs(mlets) {
        mlets.forEach((lt) => this.miniletrs.set(lt.id, lt));
        this.letrids = mlets.map((lt) => lt.id);
    }
    setNextLetr() {
        if (this.letrids.length === 0) {
            this.activeletrid = "";
        }
        else {
            this.activeletrid = this.letrids.splice(0, 1)[0];
        }
    }
    setShowAdvance(show) {
        this.showadvance = show;
    }
    setActiveId(id) {
        this.activeitemid = id;
    }
    addMatchDisplayItem(item) {
        this.displayItems.push(item);
    }
    setLoadMore(loading) {
        this.loadingmore = loading;
    }
    arrangeResult(res) {
        var _a, _b;
        // lets do something clever now!
        // id -> terms!
        // then arrange the ids in order that's it!
        for (const term of res.result) {
            for (const idata of term.indexdata) {
                if (!this.objectstermsmap.has(idata.itemid)) {
                    this.objectstermsmap.set(idata.itemid, { itemid: idata.itemid, terms: new Set(), position: [] });
                }
                (_a = this.objectstermsmap.get(idata.itemid)) === null || _a === void 0 ? void 0 : _a.terms.add(term.term);
                (_b = this.objectstermsmap.get(idata.itemid)) === null || _b === void 0 ? void 0 : _b.position.push({ term: term.term, position: idata.position });
            }
        }
        this.orderListItems = [];
        const values = Array.from(this.objectstermsmap.values());
        values.sort((val1, val2) => val1.terms.size - val2.terms.size);
        // now we have the order list that' it
        this.orderListItems = values;
        const ids = this.orderListItems.splice(0, 100);
        // lets load now
        this.loadObjects(ids.map(id => id.itemid));
    }
    loadObjects(ids) {
        if (this.activesearchtag === 'files') {
            const req = {
                letrid: this.activeletrid,
                ids: ids,
                reqid: this.searchid
            };
            Apphandler.sendMessage("driveprojectids", req);
        }
        else if (this.activesearchtag === 'messages') {
            const res = {
                reqid: this.searchid,
                letrid: this.activeletrid,
                ids: ids
            };
            Apphandler.sendMessage("messagesbyids", res);
        }
    }
    loadmore() {
        if (this.loadingmore || this.orderListItems.length === 0) {
            return;
        }
        this.setLoadMore(true);
        const ids = this.orderListItems.splice(0, 100);
        this.loadObjects(ids.map(id => id.itemid));
    }
    clearTermsMap() {
        this.objectstermsmap.clear();
        this.orderListItems = [];
        this.displayItems = [];
    }
    setLoadingMessage(msg) {
        this.loadingmessage = msg;
    }
    setSearchterm(term) {
        this.searchterm = term;
    }
    setMatchMessage(msg) {
        this.matchmessage = msg;
    }
    setSearching(searching) {
        this.searching = searching;
    }
    setActiveSearchTag(tag) {
        this.activesearchtag = tag;
    }
    setActiveSearchType(tag) {
        this.activematchtype = tag;
    }
    reset() {
        this.setSearching(false);
        this.setSearchterm("");
        this.setActiveSearchTag('files');
        this.setActiveSearchType(SearchType.Phrase);
        this.clearTermsMap();
        this.setMatchMessage("");
        this.setMiniLetrs([]);
    }
    performSearch() {
        if (!this.searchterm) {
            return;
        }
        this.setSearching(true);
        this.searchid = Math.random() + "";
        this.setMatchMessage("");
        this.clearTermsMap();
        this.setActiveId("");
        if (this.miniletrs.size === 0) {
            Apphandler.sendMessage("miniletrs", this.searchid);
            this.setLoadingMessage("Getting all letrs...");
        }
        else {
            // this will reset done ids!
            this.setMiniLetrs(Array.from(this.miniletrs.values()));
            this.setLoadingMessage("Searching...");
            this.checkAndLoadLetrs();
        }
    }
    checkAndLoadLetrs() {
        this.setNextLetr();
        if (!this.activeletrid) {
            // done!!
            this.setSearching(false);
            this.setLoadMore(false);
            if (this.displayItems.length === 0) {
                this.setMatchMessage("No match found");
            }
        }
        else {
            // now we can 
            const req = {
                reqid: this.searchid,
                letrid: this.activeletrid,
                searchterm: this.searchterm,
                operation: this.activematchtype,
                type: this.activesearchtag === 'files' ? SearchDataType.Drive : SearchDataType.Message,
                mfilter: []
            };
            Apphandler.sendMessage("letrsearch", req);
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", String)
], SearchStore.prototype, "activesearchtag", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], SearchStore.prototype, "activematchtype", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SearchStore.prototype, "searching", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SearchStore.prototype, "matchmessage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SearchStore.prototype, "loadingmessage", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], SearchStore.prototype, "orderListItems", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], SearchStore.prototype, "displayItems", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SearchStore.prototype, "miniletrs", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SearchStore.prototype, "showadvance", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SearchStore.prototype, "searchterm", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SearchStore.prototype, "objectstermsmap", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SearchStore.prototype, "loadingmore", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SearchStore.prototype, "activeitemid", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], SearchStore.prototype, "setMiniLetrs", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SearchStore.prototype, "setNextLetr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SearchStore.prototype, "setShowAdvance", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SearchStore.prototype, "setActiveId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SearchStore.prototype, "addMatchDisplayItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SearchStore.prototype, "setLoadMore", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SearchStore.prototype, "arrangeResult", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SearchStore.prototype, "clearTermsMap", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SearchStore.prototype, "setLoadingMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SearchStore.prototype, "setSearchterm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SearchStore.prototype, "setMatchMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SearchStore.prototype, "setSearching", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SearchStore.prototype, "setActiveSearchTag", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SearchStore.prototype, "setActiveSearchType", null);
